var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testPage"},[_vm._v("\n    我只是一个测试页,外部无法访问！\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-b0863a1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/share/shareTestPage.vue
// module id = null
// module chunks = 